<template>
    <div class="modal-container">
        <div class="modal font-arial">
            <div class="modal-heading-bar">
                <h1>Notifications</h1>
                <div class="modal-close" @click="closeNotifications">
                    <div class="icon icon--close"></div>
                </div>
            </div>
            <div class="modal-content">
                <div class="notification" v-for="notification in notifications" :key="notification.notification_id">
                    <h2>
                        {{ notification.notification_heading }}
                    </h2>
                    <p>
                        {{ notification.notification_body }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';

    export default {
        computed: {
            notifications() {
                return store.state.notificationsData.notifications;
            },
        },
        methods: {
            closeNotifications() {
                store.dispatch('closeNotifications');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';

    .modal-container {
        position: absolute;
        top: 80px;
        right: 0;

        max-width: 628px;

        z-index: 10;

        transition-property: right, opacity;
        transition-duration: 1s, 0.4s;
        transition-timing-function: ease;

        @media screen and (min-width: $desktop) {
            right: $desktop-side-gutter;
        }
    }

    .modal-heading-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 22px 29px 23px 30px;
        background-color: $kpmg-light-blue;
    }

    h1 {
        margin-right: 15px;
        color: white;

        font-size: 22px;
        letter-spacing: 1.2px;
    }

    h2 {
        margin-bottom: 13px;
        color: $greyish-brown;
        font-weight: bold;
        font-size: 16px;
        letter-spacing: 0.9px;

        &:not(:first-child) {
            margin-top: 35px;
        }
    }

    p {
        margin-bottom: 30px;
        color: $greyish-brown;
        letter-spacing: 0.8px;
        line-height: 1.5714285;
    }

    .modal-close {
        cursor: pointer;
    }

    .modal-content {
        padding: 38px 53px 36px 40px;
        background-color: white;
    }

    .notification {
        &:not(:first-child) {
            h2 {
                margin-top: 35px;
            }
        }

        &:not(:last-child) {
            border-bottom-color: $greyish-brown;
            border-bottom-style: solid;
            border-bottom-width: 1px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CommentsContainer.vue